<template>
    <app-content>
        <app-content-body>
            <div class="inner">
                <p class="buttons" v-if="false">
                    <a
                        class="btn btn_action btn_add"
                        :title="translations.addBlackoutContentTemplate"
                        @click.prevent="createItem"
                    ></a>
                </p>
                <h1 v-translate>Šablony blokování</h1>
            </div>

            <app-table
                clickable
                deletable
                highlight-rows-on-hover
                :data="items"
                :order="params.order"
                :page-size="params.limit"
                :loading="listLoading"
                @sort="sortItems"
                @rowClick="goToDetail"
                @deleteRow="deleteItem"
            >
              <template slot="header">
                <app-table-header-item class="field_left">
                  <app-table-header-select :label="translations.epgChannel">
                    <app-select
                        :options="tvStationsOptions"
                        v-model.trim="params.epgId"
                        @change="fetchItems(true)"
                    />
                  </app-table-header-select>

                  <app-table-header-select :label="translations.showName">
                      <app-select
                          :options="showOptions"
                          v-model.trim="params.showId"
                          @change="fetchItems(true)"
                      />
                  </app-table-header-select>
                </app-table-header-item>
                <app-table-header-item class="field_right">
                  <app-table-header-select :label="translations.enabled">
                    <app-select
                        :options="activeSelect"
                        v-model.trim="params.enabled"
                        @change="fetchItems(true)"
                    />
                  </app-table-header-select>

                  <app-table-header-select :label="translations.backoffice">
                    <app-select
                        :options="backofficeOptions"
                        v-model.trim="params.backofficeId"
                        @change="fetchItems(true)"
                    />
                  </app-table-header-select>

                  <app-checkbox
                      v-if="isAddGlobalRecordsEnabled"
                      name="addGlobal"
                      v-model="params.addGlobal"
                      @change="fetchItems(true)"
                      :title="translations.addGlobalRecords"
                      class="checkbox-disabled"
                  />

                </app-table-header-item>
              </template>
                <app-table-column sortable first attribute="showName" :label="translations.showName">
                    <template slot-scope="row">
                        <strong>{{ row._show.name }}</strong>&nbsp;<span @click.prevent.stop="showShowDetail(row._show.id)">(#{{ row._show.id }})</span>
                    </template>
                </app-table-column>

                <app-table-column :label="translations.epgChannel">
                    <template slot-scope="row">
                      <template v-if="row._epgChannels.length === 0">
                          0
                      </template>
                      <template v-else>
                      <span class="dotted">
                        {{ row._epgChannels.length }}
                        <span class="help_popup help_popup--no-wrap">
                          <strong>{{ translations.applyToSelectedTvStations }}</strong> <br />

                          <table style="margin-top: 10px;">
                            <thead>
                              <th class="first_data">Název</th>
                            </thead>
                            <tr v-for="epgChannel in row._epgChannels" :key="'ech_' + epgChannel.id">
                              <td>{{ epgChannel.name }}</td>
                            </tr>
                          </table>
                         </span>
                      </span>
                    </template>
                  </template>
                </app-table-column>

                <app-table-column :label="translations.backoffice">
                    <template slot-scope="row">
                        <template v-if="row._backoffices.length === 0">
                            0
                        </template>
                        <template v-else>
                            <span class="dotted">
                            {{ row._backoffices.length }}
                            <span class="help_popup help_popup--no-wrap">
                              <strong>{{ translations.applyToSelectedBackoffices }}</strong> <br />

                              <table style="margin-top: 10px;">
                                <thead>
                                  <th class="first_data">Název</th>
                                  <th>API Url</th>
                                </thead>
                                <tr v-for="backoffice in row._backoffices" :key="'bo_' + backoffice.id">
                                  <td>{{ backoffice.name }}</td>
                                  <td>{{ backoffice.api_url }}</td>
                                </tr>
                              </table>
                             </span>
                        </span>
                        </template>
                    </template>
                </app-table-column>

                <app-table-column :label="translations.enabled">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.enabled"
                    />
                  </template>
                </app-table-column>
                <app-table-column sortable attribute="blockedBroadcastsCount" :label="translations.blockedBroadcastsCount">
                    <template slot-scope="row">
                        {{ row._blockedBroadcastsCount }}
                    </template>
                </app-table-column>
                <app-table-column :label="translations.allowTs">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.allowTs"
                    />
                  </template>
                </app-table-column>
                <app-table-column :label="translations.allowCatchup">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.allowCatchup"
                    />
                  </template>
                </app-table-column>
                <app-table-column :label="translations.allowPvr">
                  <template slot-scope="row">
                    <app-graphic-image
                        :value="row.allowPvr"
                    />
                  </template>
                </app-table-column>

                <app-table-column sortable attribute="updated" :label="translations.updated">
                    <template slot-scope="row">
                        <div v-html="formatDate(row._updated)" />
                    </template>
                </app-table-column>

                <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
                  <app-table-pagination
                      :page="listPage"
                      :itemsPerPage="params.limit"
                      :totalCount="itemsMetadata.totalCount"
                      @pageChanged="tablePageChanged"
                  />
                </template>
            </app-table>
        </app-content-body>
    </app-content>
</template>
<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { mapActions, mapState } from 'vuex'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'BlackoutContentTemplates',
  detailRouteName: 'blackoutContentTemplate'
})

export default {
  name: 'blackoutContentTemplates',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  created() {
    this.getTvStationsOrderedByName()
    this.getShowsWithBlackoutTemplateOrderedByName()
    this.getBackoffices()
  },
  methods: {
    ...mapActions([
      'getTvStationsWithBlackoutTemplates',
      'getShowsWithBlackoutTemplate',
      'getBackoffices'
    ]),
    getTvStationsOrderedByName() {
      this.getTvStationsWithBlackoutTemplates()
    },
    getShowsWithBlackoutTemplateOrderedByName() {
      this.getShowsWithBlackoutTemplate()
    },
    showShowDetail(showId) {
      this.$router.push({
        name: 'show',
        params: {
          id: showId
        }
      })
    }
  },
  computed: {
    ...mapState({
      showOptions: (state, vm) => {
        return [
          {
            value: null,
            name: 'Všechny show'
          },
          ...state.blackoutContentTemplates.shows.map(({ _id, name, originalName }) => ({
            value: _id,
            name: name || originalName + ' (#' + _id + ')'
          }))
        ]
      },
      tvStationsOptions: (state, vm) => {
        return [
          {
            value: null,
            name: 'Všechny kanály'
          },
          {
            value: -1,
            name: 'Bez omezení kanálu'
          },
          ...state.blackoutContentTemplates.tvStations.map(({ _id, name }) => ({
            value: _id,
            name
          }))
        ]
      },
      backofficeOptions: (state, vm) => {
        return [
          {
            value: null,
            name: 'Nevybráno'
          },
          {
            value: -1,
            name: 'Bez určení Backoffice'
          },
          ...state.backoffices.backoffices.map(({ _id, name }) => ({
            value: _id,
            name: name
          }))
        ]
      }
    }),
    translations() {
      return {
        blockedBroadcastsCount: this.$gettext('Vytvořených blokací'),
        addGlobalRecords: this.$gettext('Zobrazit záznamy bez určení Backoffice'),
        applyToSelectedBackoffices: this.$gettext('Blokování je aplikováno pouze na vybrané Backoffice.'),
        applyToSelectedTvStations: this.$gettext('Blokování je aplikováno na vybrané kanály.'),
        backoffice: this.$gettext('Backoffice'),
        universalBlock: this.$gettext('Univerzální blokace'),
        epgChannel: this.$gettext('EPG Kanály'),
        enabled: this.$gettext('Povoleno'),
        allowTs: this.$gettext('TS'),
        allowCatchup: this.$gettext('CU'),
        allowPvr: this.$gettext('PVR'),
        addBlackoutContentTemplate: this.$gettext('Přidat šablonu blokování'),
        showName: this.$gettext('Pořad'),
        apiUrl: this.$gettext('API Url'),
        updated: this.$gettext('Upraveno')
      }
    },
    currentTitle() {
      return [
        this.$gettext('Šablony blokování')
      ]
    },
    activeSelect() {
      return [
        { name: this.$gettext('Nevybráno'), value: null },
        { name: this.$gettext('Ano'), value: true },
        { name: this.$gettext('Ne'), value: false }
      ]
    },
    isAddGlobalRecordsEnabled() {
      return ~~this.params.backofficeId > 0
    }
  }
}
</script>
